
import useTranslation from "@/Hooks/UseTranslation";
import ContentBody from "@/Layouts/MainLayout/components/ContentBody";
import ContentHeader from "@/Layouts/MainLayout/components/ContentHeader";
import ProjectLayout from "@/Layouts/MainLayout/ProjectLayout";
import React, { useEffect, useState } from "react";
import { Col, Row, Tab } from "react-bootstrap";
import ProgressChart from "./content/ProgressChart";
import EstimatedDeviation from "./content/EstimatedDeviation";
import OverdueTasks from "./content/OverdueTasks";
import { useDispatch, useSelector } from "react-redux";
import InterfaceActions from "@/Redux/Actions/InterfaceActions";

const ProjectDashboardPage = () => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const dashboard = useSelector((state: any) => state.DashboardReducer)

  const [ tab, setTab ] = useState('summary')

  useEffect(() => {

    const delayIsLoaded = dashboard.loadDelayStatus === 'loaded'
    const progressIsLoaded = dashboard.loadProgressStatus === 'loaded'

    if (!delayIsLoaded || !progressIsLoaded) {

      // dispatch(InterfaceActions.showLoader())
    } else {

      // dispatch(InterfaceActions.hideLoader())
    }

  }, [ dashboard.loadDelayStatus, dashboard.loadProgressStatus ])

  return (
    <ProjectLayout menuName="home" subMenuName="dashboard">
      <ContentHeader
        title={t('DASHBOARD:PageTitle')}
        buttons={[]}
        navTabs={[
          {
            label: t('DASHBOARD:SummaryTab'),
            icon: <span className="icon-datos_proyecto"></span>,
            onClick: () => setTab('summary'),
            active: tab === 'summary',
          }
        ]}
      />
      <ContentBody>
        <Tab.Content className='no-padding'>
          <Tab.Pane active={tab === 'summary'}>
            <Row>
              <Col md={6} lg={3}>
                <EstimatedDeviation />
              </Col>
              <Col md={6} lg={3}>
                <OverdueTasks />
              </Col>
              <Col md={12} lg={6}>
                <ProgressChart />
              </Col>
            </Row>
          </Tab.Pane>
        </Tab.Content>
      </ContentBody>
    </ProjectLayout>
  )
}

export default ProjectDashboardPage;
